import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './SocialButtons.css'
import {TwitterButton,EmailButton, FacebookButton} from 'react-social'
import config from '../../config'

@CSSModules(Styles,{allowMultiple:false})
export default class SocialButtons extends Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props);
  }
  render() {
    const message = this.props.message
    const link = this.props.link

    return(
       <div styleName='social-buttons'>
        <div styleName='social-buttons-inner'>
          <div styleName='share-actions'>
            <div styleName='share'>
              Share this page
            </div>
            <TwitterButton
              title='Share via Twitter'
              message={message}
              url={link}
              element='a'
              styleName='social-button-twitter'>
              <i className='fa fa-twitter' styleName='social-icon-twitter'/>
            </TwitterButton>
            <FacebookButton
              title='Share via Facebook'
              message={message}
              appId={config.socialAppId}
              url={link}
              element='a'
              styleName='social-button-facebook'>
              <i className='fa fa-facebook' styleName='social-icon-facebook'/>
            </FacebookButton>
            <EmailButton
              title='Share via E-Mail'
              message={message}
              url={link}
              element='a'
              styleName='social-button-email'>
              <i className='fa fa-envelope-o' styleName='social-icon-email'/>
            </EmailButton>
          </div>
        </div>
      </div>
    )
  }
}

